import React, { Component } from 'react';

class FocusableHeader extends Component {
    headingRef = React.createRef()
  
    componentDidMount() {
      this.headingRef.current.focus()
    }
  
    render() {
      return (
          <h4
            ref={this.headingRef}
            className="focusableHeader"
            tabIndex="-1" >
               {this.props.children}
          </h4>
      )
    }
};

export default FocusableHeader;

